import { ButtonPageLayout } from "../common/ButtonPageLayout";
import { Input } from "../common/Input";
import styles from "./LoginForm.module.scss";
import { Formik, Field } from 'formik';
import * as yup from "yup";
import { ACCESS_TOKEN_LOGIN } from "../../apollo/queries";
import { useLazyQuery } from '@apollo/react-hooks';
import { useNavigate } from "react-router-dom";
import { AccessTokenByCredentials } from "../../apollo/types/accessTokenByCredentials";
import React, { useEffect, useState } from 'react';
import { ErrorResponse } from '@apollo/client/link/error';

interface Values {
  email: string;
  password: string;
}

const initialeFormValues = {
  email: "",
  password: "",
};

const validationSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
});

export const LoginForm = () => {
  const navigate = useNavigate();
  const [invalid, setInvalid] = useState(false);
  const [login, {error, loading}] = useLazyQuery<AccessTokenByCredentials>(ACCESS_TOKEN_LOGIN, {
    onCompleted: (data) => {
      const token = data?.accessTokenByCredentials?.accessToken;
      const refreshToken = data?.accessTokenByCredentials?.refreshToken;
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("userRole", data?.accessTokenByCredentials?.role);

      const beforeLoginUrl = sessionStorage.getItem('beforeLogin');
      sessionStorage.removeItem('beforeLogin');
      navigate(beforeLoginUrl ?? beforeLoginUrl ?? '/', { replace: true });
    },
    errorPolicy: 'all',
    fetchPolicy: "no-cache"
  })

  const loginUser = (email: string, password: string) => {
    login({
      variables: {
        accessTokenByCredentialsInput: {
          emailAddress: email,
          password,
        },
      },
    }).then((response) => {
      if(response.error !== undefined && response.error.graphQLErrors.length > 0) {
          for( let err of response.error.graphQLErrors) {
             if(err.extensions.code === 'FORBIDDEN') {
                setInvalid(true)
             }
          }
      }
    })
  };

  console.log(error)
  if(error) {
    return <div>Error</div>
  }

  // @ts-ignore
  return (
      <div>
        {invalid || error ? <span className={styles.error}>Username or password is incorrect</span> : ''}
    <Formik
      validationSchema={validationSchema}
      initialValues={initialeFormValues}
      onSubmit={(values: Values) => {
        const { email, password } = values;
        setInvalid(false);
        try {
            loginUser(email, password);
          } catch (e) {
            console.log(error)
        }
    }}
    >

      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <form className={styles.formContainer} onSubmit={handleSubmit}>
          {errors.email && touched.email ? (
              errors.email === 'email must be a valid email'
                  ? <span className={styles.error}>Email format is incorrect</span>
                  : <span className={styles.error}>Email address is required</span>
          ) : null}
          <div className={styles.emailContainer}>
            <Field
              name="email"
              as={Input}
              type="text"
              placeholder="E-mail"
              onChange={handleChange}
              value={values.email}
            />
          </div>
          <div className={styles.passwordContainer}>
            {errors.password && touched.password ? (
                    <span className={styles.error}>Password required</span>
            ) : null}
            <Field
              name="password"
              as={Input}
              type="password"
              placeholder="Wachtwoord"
              onChange={handleChange}
              value={values.password}
            />
          </div>
          <ButtonPageLayout type="submit" disabled={loading}>
            { loading ? "Logging in...": "Login" }
          </ButtonPageLayout>
        </form>
      )}
    </Formik>
      </div>
  );
};
